<script lang="ts">
export default {
  props: {
    border: {
      required: false,
      type: Boolean,
      default: false,
    },
    background: {
      required: false,
      type: String,
      default: "var(--bg3)",
    },
    showCross: {
      required: false,
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "fit-content",
    },
  },
  emits: ["close"],
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<template>
  <div class="modal-overlay" @click.self="closeModal">
    <div
      class="modal-content"
      :style="{
        boxShadow: border ? '0 0 0 0.05rem var(--hairline)' : 'none',
        'background-color': background,
        width: width,
      }"
    >
      <CloseIcon
        class="close-button"
        @click="closeModal"
        v-if="!border || showCross"
      />
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  backdrop-filter: blur(10px);
}

.modal-content {
  width: fit-content;
  height: fit-content;
  padding: 28px;
  border-radius: 8px;
  position: relative;
}

.close-button {
  position: absolute;
  color: var(--text-low-emphasis);
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 15px;
  cursor: pointer;
}
</style>
